// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"537afed7","251":"a1e77d30","348":"1393c852","364":"363abcfc","571":"fff3ff5c"}[chunkId] + ".chunk.js";
};